import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import ModalSeleccionLPO from './componentFichaCliente/modalSeleccionLPO';
import ModalCancelacionAnticipada from './componentFichaCliente/modalCancelacionAnticipada';
import '../../css/huerto/fichacliente.css';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';

import Globals from '../../../Globals';
import ContractsService from '../../../services/ContractsService';
import FunctionGeneral from './functionsGeneral';

const printSlider = (fechaInicial, fechaFinal, plazo) => {
    let _widthProgreso = 0;
    let plazo_Pasado = 0;
    let fechaActual = new Date();

    if (fechaInicial === undefined || fechaFinal === undefined) return '';

    if (
        fechaActual.getFullYear() > fechaFinal.split('-')[0] ||
        (fechaActual.getMonth() > fechaFinal.split('-'[1]) &&
            fechaActual.getFullYear() === fechaFinal.split('-')[0])
    )
        _widthProgreso = 100;
    else {
        plazo_Pasado =
            (fechaActual.getFullYear() - fechaInicial.split('-')[0]) * 12 +
            (fechaActual.getMonth() + 1) -
            fechaInicial.split('-')[1];
        _widthProgreso = (plazo_Pasado / plazo) * 100;
        if (_widthProgreso > 100) _widthProgreso = 100;
    }

    return (
        <div className="o-layout__item u-1/1">
            <div className="slider">
                <div
                    className={
                        (_widthProgreso === 100 ? 'bg3 ' : '') +
                        'bg1 background-color-blue'
                    }
                    style={{ width: _widthProgreso + '%' }}
                ></div>
                <div
                    className="bg3"
                    style={{ width: 100 - _widthProgreso + '%' }}
                ></div>
            </div>

            <footer className="sliderFooter">
                <label className="labelConsT u-text-left u-float-left u-1/2">
                    {new FunctionGeneral().formatFecha(fechaInicial.split('-'))}
                </label>
                <label className="labelConsT u-text-right u-float-left u-1/2">
                    {new FunctionGeneral().formatFecha(fechaFinal.split('-'))}
                </label>
            </footer>
        </div>
    );
};

function FichaClienteLPO(props) {
    const [modalSeleccionLPO, setModalSeleccionLPO] = useState(false);
    const [modalSimulacionTodas, setmodalSimulacionTodas] = useState(false);
    const [cancelacionLPOIDSelect, setCancelacionLPOIDSelect] = useState('');
    const [nomComponent, setnomComponent] = useState([]);
    const [loadedCliente, setloadedCliente] = useState(false);
    const [
        modalCancelacionAnticipada,
        setModalCancelacionAnticipada,
    ] = useState(false);
    // const [modalSimulacionTodas, setmodalSimulacionTodas] = useState(false);
    const [
        cancelacionAnticipadaIDSelect,
        setcancelacionAnticipadaIDSelect,
    ] = useState('');

    useEffect(() => {
        {
            setTimeout(function () {
                setloadedCliente(true);
            }, 100);
            setTimeout(function () {
                props.setLoading(false);
            }, 1000);
        }
    }, [props.dataContrato]);

    useEffect(() => {
        if (!modalSeleccionLPO) setCancelacionLPOIDSelect('');
    }, [modalSeleccionLPO]);

    async function changeAccionLogs(action) {
        //     let jsonToSend = {
        //         ProdBoxId: 134,
        //         CustomerVehicle: '',
        //     };
        //     var codeAction = '';
        //     if (action === 'FichaCliente') codeAction = 'LOG_HUERTO_FICHA_CLIENTE';
        //     else if (action === 'SOLICITUD_LPA_CLIENTE')
        //         codeAction = 'LOG_HUERTO_SOLICITUD_LPA_CLIENTE';
        //     else if (action === 'SOLICITUD_LPA_DEALER')
        //         codeAction = 'LOG_HUERTO_SOLICITUD_LPA_DEALER';
        //     else if (action === 'VERLPA') codeAction = 'LOG_HUERTO_VER_LPA';
        //     else if (action === 'CERTIFICATE_LPA_CLIENTE')
        //         codeAction = 'LOG_HUERTO_CERTIFICADO_LPA_CLIENTE';
        //     else if (action === 'CERTIFICATE_LPA_DEALER')
        //         codeAction = 'LOG_HUERTO_CERTIFICADO_LPA_DEALER';
        //     else if (action === 'NEWAccion')
        //         codeAction = 'LOG_HUERTO_INICIO_ACCION';
        //     else if (action === 'GuardarAccion') {
        //         codeAction = 'LOG_HUERTO_GUARDAR_ACCION';
        //     } else if (action === 'LLAMADA')
        //         codeAction = 'LOG_HUERTO_VER_TELEFONO_ACCION';
        //     else if (action === 'EMAIL') codeAction = 'LOG_HUERTO_VER_MAIL_ACCION';
        //     else if (action === 'CONCESIONARIO')
        //         codeAction = 'LOG_HUERTO_CONCESIONARIO_ACCION';
        //     if (codeAction !== '')
        //         await new ContractsService().addActionUserDecisionService(
        //             props.cookies.get(Globals.COOKIES.JWT).AccessToken,
        //             props.cookies.get(Globals.COOKIES.USER),
        //             props.financialOperationCodeLPO,
        //             codeAction,
        //             props.UUID_ActionsActividad,
        //             JSON.stringify(jsonToSend)
        //         );
    }

    const printCliente = (datacliente, rowSelect) => {
        var infoCliente = datacliente[0];
        var nombre = 'Cargando Cliente';
        var inicialNom = 'NM';
        var inicialNomCotitular_1 = 'NM';
        var inicialNomCotitular_2 = 'NM';
        var _nomComponent = [];
        if (loadedCliente) {
            try {
                let mail = infoCliente.ClientMail.toLowerCase();
                let telefono =
                    infoCliente.ClientPhone !== ''
                        ? infoCliente.ClientPhone
                        : rowSelect.TitularPhone;
                nombre = new FunctionGeneral().capitalizeText(
                    infoCliente.ClientFullName.split(' ')
                );
                inicialNom =
                    nombre.split(' ')[1][0] !== undefined
                        ? nombre.split(' ')[0][0] + nombre.split(' ')[1][0]
                        : nombre.split(' ')[0][0];
                _nomComponent.push(
                    <div className="u-1/1">
                        <label className="u-h3 u-m-none">{nombre}</label>
                        <label
                            style={{ lineHeight: '22px', verticalAlign: 'sub' }}
                        >
                            <span
                                className={'u-text-white contatoText '}
                            ></span>
                        </label>
                    </div>
                );
                _nomComponent.push(mail);
                _nomComponent.push(telefono);
                if (nomComponent.length === 0) setnomComponent(_nomComponent);
                else if (
                    JSON.stringify(_nomComponent[0]) !==
                    JSON.stringify(nomComponent[0])
                )
                    setnomComponent(_nomComponent);
            } catch {
                //console.log( infoCliente)
            }
        }
        return (
            <div className="gridContainer">
                <div className=" o-layout">
                    <div className="o-layout__item u-2/3 u-1/1@s">
                        <div className="o-layout__item u-1/1">
                            <div className="circleNomcliente  u-text-white u-float-left">
                                {inicialNom}
                            </div>
                            <div
                                style={{ display: 'grid', paddingLeft: '10px' }}
                            >
                                <label className="labelConsT u-text-muted">
                                    Cliente LPO
                                </label>
                                <div className="u-1/1">
                                    <label className="u-h3 u-m-none">
                                        {nombre}
                                    </label>
                                    <label></label>
                                </div>
                            </div>

                            {datacliente.length > 1 && (
                                <div className="o-layout__item u-1/1">
                                    <label className="labelConsT u-text-muted u-mt u-mb-small">
                                        Perfiles asociados
                                    </label>
                                </div>
                            )}

                            {datacliente.length > 1 && loadedCliente && (
                                <div className="u-1/1">
                                    <div className="o-layout__item u-3/5">
                                        <div
                                            className="circleNomclienteAsociado u-text-white u-float-left"
                                            style={{
                                                backgroundColor: '#E63766',
                                            }}
                                        >
                                            {inicialNomCotitular_1}
                                        </div>
                                        <pre
                                            className="labelConsT u-text-brand"
                                            style={{
                                                textDecoration: 'underline',
                                                display: 'block',
                                                lineHeight: '24px',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {new FunctionGeneral().capitalizeText(
                                                datacliente[1].ClientFullName.split(
                                                    ' '
                                                )
                                            )}
                                        </pre>
                                    </div>
                                </div>
                            )}

                            {datacliente.length > 2 && loadedCliente && (
                                <div className="u-1/1">
                                    <div>
                                        <div className="o-layout__item u-3/5">
                                            <div
                                                className="circleNomclienteAsociado u-text-white u-float-left"
                                                style={{
                                                    backgroundColor: '#70A599',
                                                }}
                                            >
                                                e{inicialNomCotitular_2}
                                            </div>
                                            <pre
                                                className="labelConsT u-text-brand"
                                                style={{
                                                    textDecoration: 'underline',
                                                    display: 'block',
                                                    lineHeight: '24px',
                                                }}
                                            >
                                                {new FunctionGeneral().capitalizeText(
                                                    datacliente[2].ClientFullName.split(
                                                        ' '
                                                    )
                                                )}
                                            </pre>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const pritnContrato = (dataContrato, dataEconomical) => {
        var infodataContrato = dataContrato;
        var montoEntrada = '';
        var cuotaMes = '';
        var fechaInicial = '12-12-10';
        var fechaFinal = '12-12-12';
        var plazo = '';
        var campaña = '';
        var fechaIPO = '';
        var CapitalPendiente = '';
        var seller = '';
        var recompra = 'No';
        var kmContrato = 0;
        var plazoRenting = 0;
        try {
            cuotaMes = new FunctionGeneral().formatNum(
                infodataContrato.RentingFee.toString()
            );

            fechaInicial = infodataContrato.FormalizationDate;
            fechaInicial = fechaInicial.split('T')[0];
            fechaFinal = infodataContrato.ExpirationDate;
            fechaFinal = fechaFinal.split('T')[0];
            kmContrato = infodataContrato.KmContract;
            plazo = infodataContrato.TermMonthPeriodOption;
            campaña = infodataContrato.Campaign;
            plazoRenting = infodataContrato.TermMonthPeriodCuotas;
        } catch {}

        try {
            if (
                dataContrato.FinancialOperation ===
                dataEconomical.FinancialOperation
            )
                CapitalPendiente = new FunctionGeneral().formatNum(
                    infodataContrato.amountVMG.toString()
                );
            montoEntrada = new FunctionGeneral().formatNum(
                dataEconomical.EntryAmount.toString()
            );
        } catch {}
        return (
            <div className="gridContainer">
                <div className="o-layout__item u-1/1">
                    <div className="c-icon  c-icon--[semantic-file] colorBlue iconContrato" />
                    <label className="u-h3 u-ml-xsmall">Contrato</label>
                    <label></label>
                </div>

                <label className="labelConsT u-text-muted o-layout__item u-1/1">
                    Nº Contrato
                </label>
                <label className="labelConsT u-text-base  o-layout__item u-1/1">
                    {loadedCliente ? infodataContrato.FinancialOperation : ''}
                </label>
                <label className="labelConsT u-text-muted o-layout__item u-1/1">
                    Plazo
                </label>
                <label className="labelConsT u-text-base  o-layout__item u-1/1">
                    {plazo} {loadedCliente ? 'meses' : ''}
                </label>
                <label className="labelConsT u-text-muted o-layout__item u-1/1">
                    Km Contratados
                </label>
                <label className="labelConsT u-text-base  o-layout__item u-1/1">
                    {kmContrato} km
                </label>
                <label className="labelConsT u-text-muted o-layout__item u-1/1">
                    Campaña
                </label>
                <label className="labelConsT u-text-base  o-layout__item u-1/1">
                    {campaña}
                </label>
                <label className="labelConsT u-text-muted o-layout__item u-1/1">
                    Duración
                </label>
                {printSlider(fechaInicial, fechaFinal, plazo)}
                {montoEntrada !== '' && (
                    <label className="labelConsT u-text-muted o-layout__item u-1/1">
                        Entrada
                    </label>
                )}
                {montoEntrada !== '' && (
                    <label className="labelConsT u-text-base  o-layout__item u-1/1">
                        {montoEntrada}€
                    </label>
                )}
                <label className="labelConsT u-text-muted o-layout__item u-1/1">
                    Cuota
                </label>
                <label
                    className="labelConsT u-text-base  o-layout__item u-1/1"
                    style={{ marginBottom: '0px' }}
                >
                    {cuotaMes}€
                </label>
                {CapitalPendiente !== '' && (
                    <label
                        className="labelConsT u-text-muted o-layout__item u-1/1"
                        style={{ marginTop: '15px' }}
                    >
                        Ultima Cuota
                    </label>
                )}
                {CapitalPendiente !== '' && (
                    <label
                        className="labelConsT u-text-base  o-layout__item u-1/1"
                        style={{ marginBottom: '0px' }}
                    >
                        {CapitalPendiente}€
                    </label>
                )}
            </div>
        );
    };

    const printvehiculo = dataVihuculo => {
        var infoVihuculo = dataVihuculo;
        var brand = '';
        var fechaMatriculacion = '';
        var añoVehiculo = '';
        var modelVehiculo = '';
        var vehicleFamily = '';
        var TMAIMG = '';
        var VehicleIdentificationNumber = '';
        var VehiclePlate = '';
        var Accesorios = [];
        if (dataVihuculo !== null) {
            try {
                brand = infoVihuculo.VehicleBrand;
                modelVehiculo = infoVihuculo.VehicleModel;
                añoVehiculo = infoVihuculo.VehicleModelYear;
                vehicleFamily = infoVihuculo.VehicleFamily;
                TMAIMG = infoVihuculo.TMAIMG;
                VehicleIdentificationNumber =
                    infoVihuculo.VehicleIdentificationNumber;
                VehiclePlate = infoVihuculo.VehiclePlate;
                fechaMatriculacion = infoVihuculo.MatriculationDate.split(
                    'T'
                )[0];
                fechaMatriculacion = new FunctionGeneral().formatFecha(
                    fechaMatriculacion.split('-')
                );
                dataVihuculo.Accesorios.forEach(element => {
                    Accesorios.push(
                        <div key={element.Descripcion + element.Monto}>
                            <label className="labelConsT u-text-muted o-layout__item u-2/3">
                                Descripción
                            </label>
                            <label className="labelConsT u-text-muted o-layout__item u-1/3">
                                Monto
                            </label>
                            <label className="labelConsT u-text-base o-layout__item u-2/3">
                                {element.Descripcion}
                            </label>

                            <label className="labelConsT u-text-base o-layout__item u-1/3">
                                {new FunctionGeneral().formatNum(element.Monto)}
                                €
                            </label>
                        </div>
                    );
                });
            } catch {
                //  console.log("error vehiculo contrato")
            }
        }
        return (
            <div className="gridContainer">
                <div className="o-layout__item u-1/1">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.006"
                        height="15"
                        viewBox="0 0 19.006 15"
                    >
                        <path
                            d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                            transform="translate(0.503 0.5)"
                            fill="#fff"
                            stroke="#004666"
                            strokeWidth="1"
                        />
                    </svg>
                    <label className="u-h3 u-ml-xsmall">{' Vehículo '}</label>
                </div>

                <label className="labelConsT u-text-muted o-layout__item u-2/5">
                    Marca
                </label>
                <label className="labelConsT u-text-muted o-layout__item u-3/5">
                    Modelo
                </label>
                <label className="labelConsT u-text-base o-layout__item u-2/5">
                    {brand}
                </label>
                <label className="labelConsT u-text-base o-layout__item u-3/5">
                    {modelVehiculo}
                </label>

                {vehicleFamily && vehicleFamily !== '' && (
                    <label className="labelConsT u-text-muted o-layout__item u-1/1">
                        Familia
                    </label>
                )}
                {vehicleFamily && vehicleFamily !== '' && (
                    <label className="labelConsT u-text-base o-layout__item u-1/1">
                        {vehicleFamily}
                    </label>
                )}
                <label className="labelConsT u-text-muted o-layout__item u-2/5">
                    TMAIMG
                </label>

                <label className="labelConsT u-text-muted o-layout__item u-3/5">
                    Fecha Matriculación
                </label>
                <label className="labelConsT u-text-base o-layout__item u-2/5">
                    {TMAIMG}
                </label>
                <label className="labelConsT u-text-base o-layout__item u-3/5">
                    {fechaMatriculacion}
                </label>

                <label className="labelConsT u-text-muted o-layout__item u-2/5">
                    Matrícula
                </label>
                <label className="labelConsT u-text-muted o-layout__item u-3/5">
                    Año Modelo
                </label>
                <label className="labelConsT u-text-base o-layout__item u-2/5">
                    {VehiclePlate}
                </label>
                <label className="labelConsT u-text-base o-layout__item  u-2/5">
                    {añoVehiculo}
                </label>
                <label className="labelConsT u-text-muted o-layout__item u-3/5">
                    Bastidor
                </label>
                <label
                    className="labelConsT u-text-base o-layout__item u-3/5"
                    style={{ marginBottom: '0px' }}
                >
                    {VehicleIdentificationNumber}
                </label>
                {Accesorios.length > 0 && (
                    <div style={{ marginTop: '20px' }}>
                        <label
                            className="registerAccion colorBlue o-layout__item u-1/1"
                            style={{ marginBottom: '5px' }}
                        >
                            {' Accesorios '}
                        </label>
                        {Accesorios}
                    </div>
                )}
            </div>
        );
    };

    const printServicios = dataServicio => {
        var item = [];
        dataServicio.forEach(element => {
            item.push(
                <div key={item}>
                    <div className="o-layout__item u-1/1">
                        <label className="labelConsT u-text-muted u-1/1">
                            Descripción
                        </label>
                        <label className="labelConsT u-text-base u-text-left u-mb-none">
                            {element.ProductDescription}
                        </label>
                        <label className="labelConsT u-text-muted u-1/1">
                            Estado
                        </label>
                        <label className="labelConsT u-text-base u-text-left u-1/1">
                            {element.ProductStatus}
                        </label>
                    </div>
                </div>
            );
        });
        return (
            <div className="gridContainer">
                <div className="o-layout__item u-1/1">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 20.035 20.04"
                    >
                        <path
                            d="M11.515,14.79a1.039,1.039,0,0,1-.737-.305,4.9,4.9,0,0,1,0-6.915l3.848-3.848a4.89,4.89,0,1,1,6.915,6.915L19.782,12.4a1.042,1.042,0,1,1-1.474-1.474l1.759-1.759A2.806,2.806,0,0,0,16.1,5.2L12.252,9.043a2.809,2.809,0,0,0,0,3.968,1.042,1.042,0,0,1-.737,1.779Zm-3.692,7.54a4.89,4.89,0,0,1-3.458-8.347l1.759-1.759A1.042,1.042,0,0,1,7.6,13.7L5.839,15.456a2.806,2.806,0,0,0,3.968,3.968l3.848-3.848a2.809,2.809,0,0,0,0-3.968,1.042,1.042,0,1,1,1.474-1.474,4.9,4.9,0,0,1,0,6.915L11.281,20.9a4.858,4.858,0,0,1-3.458,1.432Z"
                            transform="translate(-2.936 -2.29)"
                            fill={'#004666'}
                        />
                    </svg>
                    <label className="u-h3 u-ml-xsmall">Servicios</label>
                </div>
                {item.length > 0 ? item : null}
            </div>
        );
    };
    const printVinculacion = dataVinculacion => {
        var item = [];
        dataVinculacion.forEach(element => {
            let _fechavencimiento = element.ProductExpirationDate.split('T')[0];
            let _fechaformalizacion = element.ProductFormalizationDate.split(
                'T'
            )[0];
            let _plazo = 0;

            _fechavencimiento = _fechavencimiento.split('-');
            _fechaformalizacion = _fechaformalizacion.split('-');
            _plazo =
                (_fechavencimiento[0] - _fechaformalizacion[0]) * 12 +
                (_fechavencimiento[1] - _fechaformalizacion[1]);

            item.push(
                <div key={item}>
                    <div className="o-layout__item u-1/1">
                        <label className="labelConsT u-text-muted u-1/1">
                            Descripción
                        </label>
                        <label className="u-text-base u-text-left">
                            {element.ProductDescription}
                        </label>
                        <label className="labelConsT u-text-muted u-1/1">
                            Duración
                        </label>
                    </div>
                    {printSlider(
                        element.ProductFormalizationDate.split('T')[0],
                        element.ProductExpirationDate.split('T')[0],
                        _plazo
                    )}
                </div>
            );
        });

        return (
            <div className="gridContainer">
                <div className="o-layout__item u-1/1">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 20.035 20.04"
                    >
                        <path
                            d="M11.515,14.79a1.039,1.039,0,0,1-.737-.305,4.9,4.9,0,0,1,0-6.915l3.848-3.848a4.89,4.89,0,1,1,6.915,6.915L19.782,12.4a1.042,1.042,0,1,1-1.474-1.474l1.759-1.759A2.806,2.806,0,0,0,16.1,5.2L12.252,9.043a2.809,2.809,0,0,0,0,3.968,1.042,1.042,0,0,1-.737,1.779Zm-3.692,7.54a4.89,4.89,0,0,1-3.458-8.347l1.759-1.759A1.042,1.042,0,0,1,7.6,13.7L5.839,15.456a2.806,2.806,0,0,0,3.968,3.968l3.848-3.848a2.809,2.809,0,0,0,0-3.968,1.042,1.042,0,1,1,1.474-1.474,4.9,4.9,0,0,1,0,6.915L11.281,20.9a4.858,4.858,0,0,1-3.458,1.432Z"
                            transform="translate(-2.936 -2.29)"
                            fill={'#004666'}
                        />
                    </svg>
                    <label className="u-h3 u-ml-xsmall">Vinculación</label>
                </div>
                {item.length > 0 ? item : null}
            </div>
        );
    };

    function returnVencimientoTable() {
        props.setFichaClienteLPO(false);
        props.setFinancialOperationCodeLPO('');
        props.setFinancialOperationCodeLPA('');
    }

    function setModalCancelacionLPOID(value) {
        //changeAccionLogs('VERLPA');
        setCancelacionLPOIDSelect(value);
        setModalSeleccionLPO(true);
    }

    const printSimulacionLPO = (dataSimulacionLPO, rowSelect) => {
        var item = [];
        dataSimulacionLPO &&
            dataSimulacionLPO.forEach(element => {
                var fechaCancelacion = [];
                var fechaVencimiento = [];
                try {
                    fechaCancelacion = element.FechaCancelacion.split('T')[0];
                    fechaCancelacion = fechaCancelacion.split('-');

                    fechaVencimiento = element.FechaPrimerVencimiento.split(
                        'T'
                    )[0];
                    fechaVencimiento = fechaVencimiento.split('-');
                    if (item.length < 5)
                        item.push(
                            <TableRow
                                style={{ height: '50px' }}
                                key={element.Id}
                            >
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {new FunctionGeneral().formatFecha(
                                        fechaCancelacion
                                    )}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {new FunctionGeneral().formatNum(
                                        element.TotalIngresar
                                    )}
                                    €
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {new FunctionGeneral().formatFecha(
                                        fechaVencimiento
                                    )}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '50px',
                                        maxWidth: '50px',
                                        marginLeft: '5px',
                                    }}
                                >
                                    <div
                                        className="c-icon c-icon--[control-eye] iconHover"
                                        onClick={() => {
                                            setModalCancelacionLPOID(
                                                element.Id
                                            );
                                        }}
                                    ></div>
                                </TableCell>
                            </TableRow>
                        );
                } catch {}
            });

        return (
            <div className="gridContainer">
                <div
                    className="o-layout__item u-1/1"
                    style={{ display: 'inline-flex' }}
                >
                    <div
                        style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            backgroundColor: '#A8ADB3',
                        }}
                        className="u-float-left"
                    ></div>
                    <label className="u-h3 u-ml-xsmall">
                        Simular cancelación parcial
                    </label>
                </div>

                <div className="o-layout__item u-1/1">
                    <Table className="tablaProyeccion">
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                    className="u-text-muted"
                                >
                                    cancelación
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                    className="u-text-muted"
                                >
                                    A liquidar
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                    className="u-text-muted"
                                >
                                    1r vcto. incluido
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '50px',
                                        maxWidth: '50px',
                                        marginLeft: '5px',
                                    }}
                                ></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{item}</TableBody>
                    </Table>
                </div>

                {/* {dataSimulacionLPO && dataSimulacionLPO.length >= 5 && (
                    <div className="sg-component-variant o-layout__item u-1/1">
                        <button
                            className="u-mb-smal c-btn  c-btn--link c-btn--secondary "
                            onClick={() => setModalSeleccionLPO(true)}
                        >
                            <i
                                className="c-btn__icon c-icon c-icon--[semantic-forward]"
                                aria-hidden="true"
                                role="img"
                            ></i>
                            <span className="c-btn__text">
                                Ver todas las simulaciones
                            </span>
                        </button>
                    </div>
                )} */}
                <div className="u-1/1  o-layout--center">
                    <button
                        className="c-btn c-btn--secondary u-p-small u-4/5 u-mv"
                        onClick={() => {
                            setModalSeleccionLPO(true);
                        }}
                    >
                        Simular cancelación por bastidor (LPO)
                    </button>
                </div>
            </div>
        );
    };

    async function setCancelacionAnticipadaId() {
        props.setFinancialOperationCodeLPA(props.operacionCodeLPO);
        setModalCancelacionAnticipada(true);
    }

    function setModalCancelacionAnticipadaID(value) {
        // changeAccionLogs('VERLPA');
        setcancelacionAnticipadaIDSelect(value);
        setModalCancelacionAnticipada(true);
    }

    const printSimulacionLPA = (dataSimulacion, rowSelect) => {
        var item = [];
        dataSimulacion.forEach(element => {
            var fechaCancelacion = [];
            var fechaVencimiento = [];
            try {
                fechaCancelacion = element.FechaCancelacion.split('T')[0];
                fechaCancelacion = fechaCancelacion.split('-');

                fechaVencimiento = element.FechaPrimerVencimiento.split('T')[0];
                fechaVencimiento = fechaVencimiento.split('-');
                if (item.length < 5)
                    item.push(
                        <TableRow style={{ height: '50px' }} key={element.Id}>
                            <TableCell
                                style={{
                                    width: '100px',
                                    maxWidth: '100px',
                                    marginLeft: '5px',
                                }}
                            >
                                {new FunctionGeneral().formatFecha(
                                    fechaCancelacion
                                )}
                            </TableCell>
                            <TableCell
                                style={{
                                    width: '100px',
                                    maxWidth: '100px',
                                    marginLeft: '5px',
                                }}
                            >
                                {new FunctionGeneral().formatNum(
                                    element.TotalIngresar
                                )}
                                €
                            </TableCell>
                            <TableCell
                                style={{
                                    width: '100px',
                                    maxWidth: '100px',
                                    marginLeft: '5px',
                                }}
                            >
                                {new FunctionGeneral().formatFecha(
                                    fechaVencimiento
                                )}
                            </TableCell>
                            <TableCell
                                style={{
                                    width: '50px',
                                    maxWidth: '50px',
                                    marginLeft: '5px',
                                }}
                            >
                                <div
                                    className="c-icon c-icon--[control-eye] iconHover"
                                    onClick={() => {
                                        setModalCancelacionAnticipadaID(
                                            element.Id
                                        );
                                    }}
                                ></div>
                            </TableCell>
                        </TableRow>
                    );
            } catch {}
        });

        return (
            <div className="gridContainer">
                <div
                    className="o-layout__item u-1/1"
                    style={{ display: 'inline-flex' }}
                >
                    <div
                        style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            backgroundColor: '#A8ADB3',
                        }}
                        className="u-float-left"
                    ></div>
                    <label className="u-h3 u-ml-xsmall">
                        Simular cancelación total
                    </label>
                </div>

                <div className="o-layout__item u-1/1">
                    <Table className="tablaProyeccion">
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                    className="u-text-muted"
                                >
                                    Cancelación
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                    className="u-text-muted"
                                >
                                    A liquidar
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '100px',
                                        maxWidth: '100px',
                                        marginLeft: '5px',
                                    }}
                                    className="u-text-muted"
                                >
                                    Primer vto. Incl.
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: '50px',
                                        maxWidth: '50px',
                                        marginLeft: '5px',
                                    }}
                                ></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{item}</TableBody>
                    </Table>
                </div>

                {/* {dataSimulacion.length >= 5 && (
                    <div className="sg-component-variant o-layout__item u-1/1">
                        <button
                            className="u-mb-smal c-btn  c-btn--link c-btn--secondary "
                            onClick={() => setmodalSimulacionTodas(true)}
                        >
                            <i
                                className="c-btn__icon c-icon c-icon--[semantic-forward]"
                                aria-hidden="true"
                                role="img"
                            ></i>
                            <span className="c-btn__text">
                                Ver todas las simulaciones
                            </span>
                        </button>
                    </div>
                )} */}
                <div className="u-1/1  o-layout--center">
                    <button
                        className="c-btn c-btn--secondary u-p-small u-4/5 u-mv"
                        onClick={() => {
                            setCancelacionAnticipadaId();
                        }}
                    >
                        Simular cancelación total (LPA)
                    </button>
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            {modalSeleccionLPO && (
                <ModalSeleccionLPO
                    setModalSeleccionLPO={setModalSeleccionLPO}
                    operacionCodeLPO={props.financialOperationCodeLPO}
                    setLoading={props.setLoading}
                    setDataSimulacionProps={props.setDataSimulacionProps}
                    cancelacionLPOIDSelect={cancelacionLPOIDSelect}
                    fecha_expirate={props.dataContrato.ExpirationDate}
                />
            )}

            {modalCancelacionAnticipada && (
                <ModalCancelacionAnticipada
                    setModalCancelacionAnticipada={
                        setModalCancelacionAnticipada
                    }
                    operacionCode={props.financialOperationCodeLPO}
                    setLoading={props.setLoading}
                    cancelacionAnticipadaIDSelect={
                        cancelacionAnticipadaIDSelect
                    }
                    setDataSimulacionProps={props.setDataSimulacionProps}
                    fecha_expirate={props.dataContrato.ExpirationDate}
                    TitularNIF={props.dataCliente?.[0]}
                    mail={nomComponent[1] ?? ''}
                    changeAccionLogs={changeAccionLogs}
                    esCancelacionCliente={true}
                />
            )}

            <div className="o-layout" style={{ minHeight: 70 + 'px' }}>
                <div className="o-layout__item u-3/5 u-mt-none"></div>

                <div className="o-layout__item u-2/5 u-text-right">
                    <button
                        className="c-btn  u-text-brand"
                        onClick={() => returnVencimientoTable()}
                    >
                        <span className="mideltextfilter">
                            VOLVER AL LISTADO
                        </span>
                    </button>
                </div>
            </div>

            <div className="o-layout">
                <div className="o-layout__item u-1/3 u-1/2@m u-1/1@s">
                    <div className="u-1/1">
                        {pritnContrato(
                            props.dataContrato,
                            props.dataEconomical
                        )}
                    </div>
                </div>

                <div className="o-layout__item u-1/3 u-1/2@m u-1/1@s">
                    <div className="u-1/1">
                        {printvehiculo(props.dataVehiculo)}
                    </div>
                </div>

                <div
                    className="o-layout__item u-1/3 u-1/1@m"
                    style={
                        window.innerWidth <= 920 && window.innerWidth >= 720
                            ? { display: 'flex' }
                            : {}
                    }
                >
                    <div
                        className="u-1/1 u-1/2@m u-1/1@s"
                        style={
                            window.innerWidth <= 920 && window.innerWidth >= 720
                                ? { paddingLeft: '10px' }
                                : {}
                        }
                    >
                        {printSimulacionLPA(props.dataSimulacion)}
                    </div>
                    <div
                        className="u-1/1 u-1/2@m u-1/1@s"
                        style={
                            window.innerWidth <= 920 && window.innerWidth >= 720
                                ? { paddingLeft: '10px' }
                                : {}
                        }
                    >
                        {printSimulacionLPO(
                            props.dataSimulacionLPO || props.dataSimulacion
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withCookies(withRouter(FichaClienteLPO));
